import React from 'react'

export default function LoadingBtn() {
    return (
        <div className="text-center my-5"> 
            <button type="button" className="btn spinner spinner-darker-primary spinner-right"></button>
        </div>
    )
}
